import { fetchAPI } from "./client";
import { InvestorType } from "../persona";

export interface CompanyProfile {
  id: string;
  name: string;
  mode: "startup" | "vc";
  sector: string | null;
  stage: string | null;
  investorType: InvestorType | null;
  website: string | null;
  description: string | null;
  logoUrl: string | null;
}

export interface CompanyProfileInput {
  companyId: string;
  name: string;
  sector?: string;
  stage?: string;
  investorType?: string;
  website?: string;
  description?: string;
  // Base64 image data (data URI accepted). Omitted leaves the current logo.
  logo?: string;
}

export const CompanyAPI = {
  getProfile: (companyId: string) => {
    const query = new URLSearchParams({ companyId });
    return fetchAPI(`/company?${query.toString()}`) as Promise<CompanyProfile>;
  },

  updateProfile: (input: CompanyProfileInput) => {
    return fetchAPI("/company", {
      method: "PUT",
      body: JSON.stringify(input),
    }) as Promise<CompanyProfile>;
  },
};
